<template>
  <div>
    <section
      class="back-section d-flex  flex-column align-items-center storage-container"
    >
      <input
        id="customFile"
        type="file"
        class="form-control transparent-btn"
        @change="uploadFile"
      />
      <ul>
        <li
          v-for="data in imgData"
          :key="data.id"
          class="d-flex align-items-center justify-content-between"
        >
          <div>
            <p>
              <span class="mr-3">
                id : {{ data.id.slice(0, 15) + '...' }}
              </span>
              <button class="transparent-btn" @click="delImg(data.id)">
                刪除
              </button>
            </p>
          </div>
          <img :src="data.path" />
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  created() {
    this.axios.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
    this.upDateData();
  },
  data() {
    return {
      token: '',
      imgData: [],
    };
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    delImg(id) {
      const url = `${this.user.apiPath}api/${this.user.uuid}/admin/storage/${id}`;
      this.$fire({
        title: '確定要刪除?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '是',
        cancelButtonText: '否',
      }).then(result => {
        if (result.value === true) {
          this.axios
            .delete(url)
            .then(res => {
              if (res.data.status === 200) {
                this.$fire({
                  title: `刪除成功`,
                  type: 'success',
                  timer: 3000,
                });
              }
              this.imgData = this.imgData.filter(item => {
                return item.id !== id;
              });
            })
            .catch(err => {
              this.$fire({
                title: `${err}`,
                type: 'error',
                timer: 3000,
              });
            });
          return;
        }
      });
    },
    upDateData() {
      const url = `${this.user.apiPath}api/${this.user.uuid}/admin/storage`;
      this.axios(url, {
        page: '1',
        paged: '100',
        orderBy: 'created_at, updated_at',
        sort: 'desc, asc',
      })
        .then(res => {
          this.imgData = res.data.data;
        })
        .catch(err => {
          this.$fire({
            title: `${err}`,
            type: 'error',
            timer: 3000,
          });
        });
    },
    uploadFile() {
      const formData = new FormData();
      const uploadedfile = document.querySelector('#customFile').files[0];
      formData.append('file', uploadedfile);
      const url = `${this.user.apiPath}api/${this.user.uuid}/admin/storage`;
      this.axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          if (res.status === 200) {
            this.$fire({
              title: `新增成功`,
              type: 'success',
              timer: 3000,
            });
            this.upDateData();
          } else {
            this.$fire({
              title: `${res.data.data.message}`,
              type: 'error',
              timer: 3000,
            });
          }
        })
        .catch(err => {
          this.$fire({
            title: `${err}`,
            type: 'error',
            timer: 3000,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
